import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { renderDate } from '../util';
import { HitProps } from './_types';
import { HitHeadline } from './_HitHeading';

export const EventHit = ({ hit }: HitProps) => {
  return (
    <div>
      <div className={classnames('mb-2')}>Event &emsp;| &emsp;{hit.eventCategory?.join(', ')}</div>
      <HitHeadline hit={hit}>
        <Highlight hit={hit} attribute="pageTitle" />
      </HitHeadline>
      {renderDate(hit.startDate)}
      <Snippet
        hit={hit}
        attribute="description"
        className={classnames('line-clamp-4', 'md:line-clamp-2')}
      />
    </div>
  );
};
